export default __webpack_public_path__ + "static/media/Banner_Barca2.00c6b228.png";